/**
 * Kept out of `ItunesButton.schema.ts` on purpose: that module builds its yup schemas at module
 * scope, so any value import from it drags `yup` (and, transitively, ~180 `lodash-es` modules)
 * into the importer's chunk. The mappers only need this list, so it lives on its own.
 */
export const itunesLanguages = [
	...(['userLang', 'da', 'de', 'en', 'es', 'fr', 'it', 'jp', 'ko', 'nl', 'no', 'pl', 'pt', 'ru', 'sv', 'tr'] as const),
]

export type ItunesLanguages = (typeof itunesLanguages)[number]
